<template>
  <div class="fshr-searchMenu">
    <div class="fshr-searchMenu-seasons">
      <a
        href=""
        @click.prevent="openGlobalFilter"
        class="fshr-searchMenu-handler"
        >{{getTranslation('vyhledavani')}}</a
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "global-filter-launcher",
  components: {},
  data: function () {
    return {
      filterSettings: null,
      loading: false,
    };
  },
  mounted: function () {},
  methods: {
    openGlobalFilter() {
      this.$root.$emit("openCloseAccordion", "globalfilter");
    },
  },
  provide() {},
  props: {
    translations: {
      required: false,
      type: Object,
      default: function (){
        return {
          vyhledavani: "Vyhledávání"
        }
      }
    }
  },
};
</script>

<style scoped></style>
